/* assets/contact-info.js — Contact form (iframe submit + popup), brand-aligned.
   Initializes every [data-contact-section] on the page. */
(function () {
  function initContact(root) {
    if (!root || root.dataset.contactInit === '1') return;
    root.dataset.contactInit = '1';

    var form         = root.querySelector('form');
    var nameInput    = root.querySelector('[data-contact-name]');
    var emailInput   = root.querySelector('[data-contact-email]');
    var subjectInput = root.querySelector('[data-contact-subject]');
    var messageInput = root.querySelector('[data-contact-message]');
    var submitBtn    = root.querySelector('[data-contact-submit]');
    var btnText      = root.querySelector('[data-contact-btn-text]');
    var iframe       = root.querySelector('[data-contact-iframe]');
    if (!form || !nameInput || !emailInput || !subjectInput || !messageInput || !submitBtn || !iframe) return;

    var MESSAGES = {
      successTitle: root.dataset.successTitle || 'Message sent!',
      successBody:  root.dataset.successBody  || "Thanks for reaching out. We'll get back to you within 1-2 business days.",
      invalidTitle: 'Please complete all fields',
      invalidBody:  'Make sure your name, email, subject, and message are filled in correctly.',
      failedTitle:  'Something went wrong',
      failedBody:   'Please try again in a moment.'
    };
    var BTN_TEXT_DEFAULT = root.dataset.btnText || 'Send Message';

    var overlay = document.createElement('div');
    overlay.setAttribute('data-contact-popup', '');
    overlay.style.cssText = 'position:fixed;inset:0;z-index:99999;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,0.65);padding:16px;';
    overlay.innerHTML =
      '<div style="background:#fff;border-radius:16px;box-shadow:0 25px 50px -12px rgba(0,0,0,0.25);max-width:420px;width:100%;padding:28px 24px;text-align:center;position:relative;">' +
        '<button type="button" data-pop-close aria-label="Close" style="position:absolute;top:12px;right:12px;width:32px;height:32px;display:flex;align-items:center;justify-content:center;background:transparent;border:none;cursor:pointer;color:var(--color-muted,#64748B);">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
        '</button>' +
        '<div data-pop-icon style="display:flex;justify-content:center;margin-bottom:12px;"></div>' +
        '<h3 data-pop-title style="font-size:18px;font-weight:700;color:var(--color-primary,#053C54);margin:0 0 8px;"></h3>' +
        '<p data-pop-body style="font-size:14px;color:var(--color-muted,#64748B);margin:0 0 20px;line-height:1.5;"></p>' +
        '<button type="button" data-pop-ok style="background:var(--color-accent,#EA3D3D);color:#fff;padding:10px 32px;border:none;border-radius:999px;font-size:14px;font-weight:600;cursor:pointer;">OK</button>' +
      '</div>';
    document.body.appendChild(overlay);

    var popupIcon  = overlay.querySelector('[data-pop-icon]');
    var popupTitle = overlay.querySelector('[data-pop-title]');
    var popupBody  = overlay.querySelector('[data-pop-body]');
    var popupClose = overlay.querySelector('[data-pop-close]');
    var popupOk    = overlay.querySelector('[data-pop-ok]');

    function setIcon(type) {
      var bgs = { success:'#dcfce7', info:'#dbeafe', error:'#fee2e2' };
      var fgs = { success:'#16a34a', info:'#2563eb', error:'#dc2626' };
      var paths = {
        success:'<polyline points="20 6 9 17 4 12"></polyline>',
        info:'<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>',
        error:'<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>'
      };
      popupIcon.innerHTML = '<div style="width:56px;height:56px;border-radius:50%;background:'+bgs[type]+';display:flex;align-items:center;justify-content:center;"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="'+fgs[type]+'" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">'+paths[type]+'</svg></div>';
    }
    function openPopup(type, title, body) {
      setIcon(type); popupTitle.textContent = title; popupBody.textContent = body;
      overlay.style.display = 'flex'; document.body.style.overflow = 'hidden';
    }
    function closePopup() { overlay.style.display = 'none'; document.body.style.overflow = ''; }
    popupClose.addEventListener('click', closePopup);
    popupOk.addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePopup(); });

    function isValidEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
    function setLoading(loading) {
      submitBtn.disabled = loading;
      if (btnText) btnText.textContent = loading ? 'Sending...' : BTN_TEXT_DEFAULT;
    }

    var pendingSubmission = null;
    var submissionStartedAt = 0;

    form.addEventListener('submit', function (e) {
      var name    = (nameInput.value    || '').trim();
      var email   = (emailInput.value   || '').trim();
      var subject = (subjectInput.value || '').trim();
      var message = (messageInput.value || '').trim();
      if (!name || !subject || !message || !isValidEmail(email)) {
        e.preventDefault();
        openPopup('error', MESSAGES.invalidTitle, MESSAGES.invalidBody);
        return;
      }
      pendingSubmission = { name: name, email: email };
      submissionStartedAt = Date.now();
      setLoading(true);
    });

    iframe.addEventListener('load', function () {
      if (!pendingSubmission) return;
      if (Date.now() - submissionStartedAt < 50) return;
      setTimeout(function () {
        var resolvedSuccess = true, isChallenge = false;
        try {
          var iframeUrl = iframe.contentWindow.location.href.toLowerCase();
          if (iframeUrl.indexOf('/challenge') !== -1) { isChallenge = true; resolvedSuccess = false; }
        } catch (e) {}
        if (isChallenge) {
          openPopup('error', MESSAGES.failedTitle, 'Please try again in a moment.');
        } else if (resolvedSuccess) {
          openPopup('success', MESSAGES.successTitle, MESSAGES.successBody);
          nameInput.value = ''; emailInput.value = ''; subjectInput.value = ''; messageInput.value = '';
        } else {
          openPopup('error', MESSAGES.failedTitle, MESSAGES.failedBody);
        }
        setLoading(false);
        pendingSubmission = null;
      }, 200);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-contact-section]').forEach(initContact);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
